export default __webpack_public_path__ + "static/media/534352.37a1c105.svg";